var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-loading",style:({ display: _vm.show ? 'flex' : 'none' })},[_c('div',{staticClass:"app-ld-bg"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }